import type { RegionCode } from '@volvo-cars/market-sites';

export const countriesMapping = new Map<RegionCode, string[]>([
  ['CH', ['CH', 'LI']],
]);
